import logoPng from './images/log.png';
import logo_white from './images/logo-white.png';
import { CosImage } from '../cos-image';

type LogoSource = string | { src: string };

const LOGO_PATH = {
  white: 'web-ui/logo/images/log.png',
  transparent: 'web-ui/logo/images/logo-white.png',
} as const;

export const Logo = ({
  type = 'white',
  className = 'w-[120px]',
  src,
  path,
}: {
  type?: 'white' | 'transparent';
  className?: string;
  src?: LogoSource;
  path?: string;
}) => {
  const fallback = src ?? (type === 'transparent' ? logo_white : logoPng);
  const cosPath = path ?? LOGO_PATH[type];
  return (
    <CosImage
      alt="腾讯SSV官网"
      path={cosPath}
      fallbackSrc={fallback}
      className={className}
    />
  );
};
